import { IOrder } from 'src/types/order';
import { OrderFormData } from 'src/screens/General/screens/Orders/components/OrderForm';
export const toFormValues = (order: Partial<IOrder>, types: any): Partial<OrderFormData> => {
    const {
        student,
        serviceType,
        serviceTypeProvider,
        orderType,
        status,
        authorizationSource,
        allocatedPeriod,
        orderSubtype,
        orderCaseType,
        allocatedHours,
        allocatedMoney,
        referralSource,
        ...data
    }: Partial<IOrder> = order;
    const dataForm: Partial<OrderFormData> = { ...data };
    dataForm.allocatedHours = `${allocatedHours}`;
    dataForm.allocatedMoney = `${allocatedMoney}`;

    dataForm.studentDropDown = student
        ? { label: `${student.firstName} ${student.lastName}`, value: student.id }
        : undefined;

    dataForm.orderSubtypeDropDown = orderSubtype
        ? types.OrderSubtype.find((it: SelectObject) => it.value === orderSubtype)
        : undefined;

    dataForm.orderCaseTypeDropDown = orderCaseType
        ? types.orderCaseTypeValues.find((it: SelectObject) => it.value === orderCaseType)
        : undefined;

    dataForm.orderReferralSourceDropDown = referralSource
        ? types.orderReferralSourceValues.find((it: SelectObject) => it.value === referralSource)
        : undefined;

    dataForm.allocatedPeriodDropDown = allocatedPeriod
        ? types.AllocatedPeriod.find((it: SelectObject) => it.value === +allocatedPeriod)
        : undefined;
    dataForm.authorizationSourceDropDown = authorizationSource
        ? types.AuthorizationSource.find((it: SelectObject) => it.value === authorizationSource)
        : undefined;
    dataForm.statusDropDown = status ? types.OrderStatus.find((it: SelectObject) => it.value === status) : undefined;

    dataForm.serviceTypeProviderDropDown = serviceTypeProvider
        ? types.ServiceTypeProviders.find((it: SelectObject) => it.value === serviceTypeProvider)
        : undefined;

    dataForm.orderTypeDropDown = orderType
        ? types.OrderTypes.find((it: SelectObject) => it.value === orderType)
        : undefined;

    dataForm.serviceTypeDropDown = serviceType
        ? { label: serviceType.title ? serviceType.title : `cpt: ${serviceType.cpt}`, value: serviceType.id }
        : undefined;

    return dataForm;
};
